
import {ExtranetPrivateRoutes} from "./routing/ExtranetPrivateRoutes";
import {PrestationsRoutes} from "./routing/PrestationsRoutes";
import {DecomptesRoutes} from "./routing/DecomptesRoutes";

export const privateRoutes = [
    ...ExtranetPrivateRoutes,
    // ...PrestationsRoutes,
    ...DecomptesRoutes
];
